"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TTableContent = void 0;
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var react_1 = __importStar(require("react"));
var react_table_1 = require("react-table");
var TTableHeadRow_1 = __importDefault(require("./TTableHeadRow"));
var TTablePagination_1 = __importDefault(require("./TTablePagination"));
var TTableToolbar_1 = __importDefault(require("./TTableToolbar"));
var constants_1 = require("./utils/constants");
var utils_1 = require("./utils/utils");
var useStyles = styles_1.makeStyles(function (theme) { return ({
    container: {
        maxHeight: '65vh',
    },
    collapseCellStyle: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        whiteSpace: 'pre-line',
        '-webkit-line-clamp': '3',
        '-webkit-box-orient': 'vertical',
        '& > a': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            whiteSpace: 'pre-line',
            '-webkit-line-clamp': '3',
            '-webkit-box-orient': 'vertical',
        },
    },
    expandCellStyle: {
        whiteSpace: 'pre-line',
    },
    expandHeaderCellStyle: {
        '@media(max-height: 1080px)': {
            display: 'block',
            maxHeight: 150,
            overflowY: 'auto',
        },
    },
}); });
var TTableContent = function (props) {
    var visibleSettings = props.visibleSettings, registryCode = props.registryCode, data = props.data, columns = props.columns, multiSort = props.multiSort, onFetchData = props.onFetchData, manualSortBy = props.manualSortBy, manualFilters = props.manualFilters, manualPagination = props.manualPagination, presetsSetting = props.presetsSetting, rowActions = props.rowActions, lang = props.lang, saveListPresets = props.saveListPresets, fetchUserRoleList = props.fetchUserRoleList, upload = props.upload, isAdmin = props.isAdmin, setReloadData = props.setReloadData;
    var defaultVisibleColumnCodes = react_1.useMemo(function () {
        return columns.filter(function (_) { return !_.groupCode; }).map(function (_) { return _.columnCode; });
    }, [columns]);
    var _a = react_1.useState(defaultVisibleColumnCodes), currentColumnCodes = _a[0], setCurrentColumnCodes = _a[1];
    var _b = react_1.useState(0), triggerFetchData = _b[0], setTriggerFetchData = _b[1];
    var _c = react_1.useState(0), triggerRerenderModal = _c[0], setTriggerRerenderModal = _c[1];
    var isWithPresets = visibleSettings.toolbar.isWithPresets;
    react_1.useEffect(function () {
        !isWithPresets && setCurrentColumnCodes(defaultVisibleColumnCodes);
    }, [defaultVisibleColumnCodes, isWithPresets]);
    var handleChangeVisibleColumns = react_1.useCallback(function (newVisibleColumnCodes) {
        var visibleColumnCodes = newVisibleColumnCodes.length ? newVisibleColumnCodes : defaultVisibleColumnCodes;
        setCurrentColumnCodes(visibleColumnCodes);
    }, [setCurrentColumnCodes]);
    var visibleColumnsData = react_1.useMemo(function () { return columns.filter(function (_) { return currentColumnCodes.includes(_.columnCode); }); }, [columns, currentColumnCodes]);
    var defaultSortBy = react_1.useMemo(function () {
        var defaultSortBy = [];
        visibleColumnsData.some(function (column) {
            var isWithDefaultSort = column.defaultSort;
            if (isWithDefaultSort) {
                var isDescSort = column.defaultSort === 'desc';
                defaultSortBy = [
                    {
                        id: column.columnCode,
                        desc: isDescSort,
                    },
                ];
                return isWithDefaultSort;
            }
        });
        return defaultSortBy;
    }, [columns]);
    var initialState = react_1.useMemo(function () { return ({
        pageSize: constants_1.DEFAULT_PAGE_SIZE,
        pageIndex: 0,
        columnOrder: [],
        hiddenColumns: [],
        visibleColumns: defaultVisibleColumnCodes,
        sortBy: defaultSortBy,
        filters: [],
    }); }, [defaultVisibleColumnCodes]);
    var _d = react_1.useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var _e = react_table_1.useTable({
        data: data.rows,
        columns: visibleColumnsData,
        manualSortBy: manualSortBy,
        manualFilters: manualFilters,
        manualPagination: manualPagination,
        filterTypes: {},
        pageCount: -1,
        initialState: initialState,
        autoResetHiddenColumns: false,
    }, react_table_1.useFilters, react_table_1.useSortBy, react_table_1.usePagination, react_table_1.useColumnOrder), getTableProps = _e.getTableProps, getTableBodyProps = _e.getTableBodyProps, headerGroups = _e.headerGroups, visibleColumns = _e.visibleColumns, rows = _e.rows, prepareRow = _e.prepareRow, setAllFilters = _e.setAllFilters, state = _e.state, setPageSize = _e.setPageSize, gotoPage = _e.gotoPage, setColumnOrder = _e.setColumnOrder, setSortBy = _e.setSortBy, setFilter = _e.setFilter;
    var firstRowRef = react_1.useRef(null);
    var handleChangeTableState = react_1.useCallback(function (state) {
        setTimeout(function () {
            setSortBy(state.sortBy);
            setAllFilters(function () { return state.filters; });
            setPageSize(state.pageSize);
            setColumnOrder(state.columnOrder || []);
            setTriggerRerenderModal(function (triggerRerenderModal) { return ++triggerRerenderModal; });
        }, 0);
    }, [setSortBy, setFilter, setPageSize, setColumnOrder, setTriggerRerenderModal]);
    var thenFetchData = react_1.useCallback(function () {
        var _a;
        setIsLoading(false);
        if (firstRowRef) {
            (_a = firstRowRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                behavior: 'smooth',
                block: 'end',
                inline: 'nearest',
            });
        }
    }, [setIsLoading, firstRowRef]);
    var sortBy = state.sortBy, filters = state.filters, pageIndex = state.pageIndex, pageSize = state.pageSize;
    var columnsForTableQuery = headerGroups.map(function (_) { return _.headers; }).reduce(function (a, b) { return a.concat(b); }, []);
    var tableQueryData = utils_1.tableQuery(sortBy, filters, pageIndex + 1, pageSize, columnsForTableQuery);
    var triggerLoadData = function () {
        setTriggerFetchData(function (triggerFetchData) { return ++triggerFetchData; });
    };
    var loadData = react_1.useCallback(function () {
        if (onFetchData) {
            setIsLoading(true);
            //Не можем использовать onFetchData(...).then(thenFetchData) т. к. работает debounce и не возвращает обещание
            onFetchData(tableQueryData, thenFetchData);
        }
    }, [onFetchData, sortBy, filters, pageIndex, pageSize, thenFetchData, triggerFetchData]);
    react_1.useEffect(function () {
        setReloadData && setReloadData(loadData);
    }, [loadData]);
    var handleChangePage = react_1.useCallback(function (e, page) {
        gotoPage(page - 1);
    }, [gotoPage]);
    var handleChangeRowsPerPage = react_1.useCallback(function (e) {
        setPageSize(Number(e.target.value));
    }, [setPageSize]);
    var _f = useStyles(), collapseCellStyle = _f.collapseCellStyle, expandCellStyle = _f.expandCellStyle, container = _f.container, expandHeaderCellStyle = _f.expandHeaderCellStyle;
    var isWithCollapseRowMode = visibleSettings.toolbar.isWithCollapseRowMode;
    var _g = react_1.useState(isWithCollapseRowMode ? 'collapse' : 'expand'), mode = _g[0], setMode = _g[1];
    var changeMode = function () { return (mode === 'collapse' ? setMode('expand') : setMode('collapse')); };
    var modeStyle = {
        collapse: {
            cellStyle: collapseCellStyle,
            headerStyle: collapseCellStyle,
        },
        expand: {
            cellStyle: expandCellStyle,
            headerStyle: expandHeaderCellStyle,
        },
    };
    var changeVisibleColumns = react_1.useCallback(function (columnCode) {
        var visibleColumnCodes = visibleColumns.map(function (column) { return column.columnCode; });
        var newVisibleColumnCodes = __spreadArrays(visibleColumnCodes);
        var codeIndex = newVisibleColumnCodes.indexOf(columnCode);
        var changedColumn = columns.find(function (column) { return column.columnCode === columnCode; });
        if (changedColumn) {
            changedColumn.rerenderKey = ++changedColumn.rerenderKey;
        }
        if (codeIndex !== -1) {
            resetColumn(columnCode);
            newVisibleColumnCodes.splice(codeIndex, 1);
        }
        else {
            newVisibleColumnCodes.push(columnCode);
        }
        handleChangeVisibleColumns(newVisibleColumnCodes);
    }, [columns, visibleColumns, handleChangeVisibleColumns]);
    var resetColumn = react_1.useCallback(function (columnCode) {
        var isWithFilters = !!state.filters.length;
        var isWithSorts = !!state.sortBy.length;
        if (isWithFilters || isWithSorts) {
            var column_1 = visibleColumns.find(function (column) { return column.columnCode === columnCode; });
            if (column_1) {
                if (column_1.canFilter && isWithFilters) {
                    var currentColumnFilters = state.filters.find(function (filter) { return filter.id === column_1.id; });
                    if (currentColumnFilters) {
                        column_1.setFilter(undefined);
                    }
                }
                if (isWithSorts) {
                    var currentColumnSort = state.sortBy.find(function (filter) { return filter.id === column_1.id; });
                    if (currentColumnSort) {
                        column_1.clearSortBy();
                    }
                }
            }
        }
    }, [state, visibleColumns]);
    return (react_1.default.createElement(core_1.Paper, null,
        react_1.default.createElement(TTableToolbar_1.default, { visibleSettings: visibleSettings, registryCode: registryCode, initialState: initialState, tableState: state, allColumns: columns, visibleColumns: visibleColumns, headerGroups: headerGroups, setAllFilters: setAllFilters, presetsSetting: presetsSetting, handleChangeVisibleColumns: handleChangeVisibleColumns, changeVisibleColumns: changeVisibleColumns, onChangeTableState: handleChangeTableState, triggerRerenderModal: triggerRerenderModal, lang: lang, saveListPresets: saveListPresets, fetchUserRoleList: fetchUserRoleList, upload: function () { return upload(tableQueryData); }, isAdmin: isAdmin, loadData: loadData, triggerLoadData: triggerLoadData, changeMode: changeMode, mode: mode }),
        isLoading && react_1.default.createElement(core_1.LinearProgress, null),
        react_1.default.createElement(core_1.TableContainer, { className: container },
            react_1.default.createElement(core_1.Table, __assign({ stickyHeader: true }, getTableProps()),
                react_1.default.createElement(core_1.TableHead, null,
                    react_1.default.createElement(TTableHeadRow_1.default, { visibleSettings: visibleSettings, headerGroups: headerGroups, setColumnOrder: setColumnOrder, multiSort: !!multiSort, withRowActions: !!rowActions, modeStyle: modeStyle[mode].headerStyle, changeVisibleColumns: changeVisibleColumns })),
                react_1.default.createElement(core_1.TableBody, __assign({}, getTableBodyProps()), rows.map(function (row, index) {
                    prepareRow(row);
                    return (react_1.default.createElement(core_1.TableRow, __assign({}, row.getRowProps(), (index === 0 ? { ref: firstRowRef } : {}), { hover: true }),
                        row.cells.map(function (cell) {
                            var style = cell.column.style;
                            return (react_1.default.createElement(core_1.TableCell, __assign({}, cell.getCellProps(), (style && { style: style })),
                                react_1.default.createElement("div", { className: modeStyle[mode].cellStyle }, cell.render('Cell'))));
                        }),
                        rowActions ? (react_1.default.createElement(core_1.TableCell, { align: "right" }, rowActions(row.original, loadData))) : null));
                })))),
        react_1.default.createElement(core_1.Box, { pl: 6, pt: 5, pb: 5, pr: 5 },
            react_1.default.createElement(TTablePagination_1.default, { count: data.count, page: pageIndex, onChangePage: handleChangePage, onChangeRowsPerPage: handleChangeRowsPerPage, rowsPerPage: pageSize, rowsPerPageOptions: constants_1.PAGE_SIZES, pagingInfoMessageId: "ttable.pagingInfo", pagingInfoMessageIdIfNull: "ttable.pagingInfoIfNull" }))));
};
exports.TTableContent = TTableContent;
